"use client";

import { buttonVariants } from "@/components/ui/button";
import { ChevronDown, CloudUpload, FolderPlus, Settings } from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import { useRouter } from "next/navigation";
import { useStorageQuery } from "../../../hooks/storageQueryProvider";
import { t } from "@/lib/localization";
import { useLocale } from "@/hooks/useLocale";

export default function StorageActions() {
    const { dir } = useLocale();
    const { setCreateFolderModalOpen, settings, parentFolder } =
        useStorageQuery();

    const router = useRouter();

    if (!settings.actionsButton) return null;

    const uploadVideos = () => {
        let href = "/ai/upload-videos";

        if (parentFolder) {
            href += `?folderId=${parentFolder.id}`;
        }

        router.push(href);
    };

    const createNewFolder = () => {
        setCreateFolderModalOpen(true);
    };

    const goToSettings = () => {
        router.push("/storage/settings");
    };

    const hasCreateFolder = settings.actionsButton.createFolder;
    const hasUploadVideos = settings.actionsButton.uploadVideos;
    const hasSettings = settings.actionsButton.storageSettings;

    return (
        <DropdownMenu dir={dir}>
            <DropdownMenuTrigger
                className={cn(
                    buttonVariants({ variant: "default" }),
                    "h-9 flex flex-row gap-1.5 w-fit items-center"
                )}
            >
                {t("storage.header.actions")}
                <ChevronDown className="size-5" />
            </DropdownMenuTrigger>
            <DropdownMenuContent>
                {hasCreateFolder && (
                    <DropdownMenuItem
                        onClick={createNewFolder}
                        className="flex flex-row gap-2 items-center"
                    >
                        <FolderPlus className="size-4" />
                        {t("storage.header.actions.create-folder")}
                    </DropdownMenuItem>
                )}
                {hasCreateFolder && (hasUploadVideos || hasSettings) && (
                    <DropdownMenuSeparator />
                )}
                {hasUploadVideos && (
                    <DropdownMenuItem
                        onClick={uploadVideos}
                        className="flex flex-row gap-2 items-center"
                    >
                        <CloudUpload className="size-4" />
                        {t("storage.header.actions.upload-videos")}
                    </DropdownMenuItem>
                )}
                {hasSettings && (
                    <DropdownMenuItem
                        onClick={goToSettings}
                        className="flex flex-row gap-2 items-center"
                    >
                        <Settings className="size-4" />
                        {t("storage.header.actions.settings")}
                    </DropdownMenuItem>
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
